module.exports = __webpack_public_path__ + "/img/Header-Male-Straight-juB9iB.svg";